import { render, staticRenderFns } from "./side-file.vue?vue&type=template&id=e99a1b68"
import script from "./side-file.vue?vue&type=script&lang=js"
export * from "./side-file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports